import { faChevronLeft } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Box,
  Button,
  OutlinedInput,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useFormik } from "formik";
import { useEffect } from "react";
import { getBenef } from "../../../Store/storages/BeneficiarioStorage";
import { TipoAtendRetorno } from "../../../interfaces/entities/PAVirtual/TipoAtendRetorno";
import { TipoOrientacaoTriagem } from "../../../interfaces/entities/TipoOrientacaoTriagem";
import { EmailCelularValidation } from "../../../interfaces/validation/EmailCelularValidation";
import { cellphoneMask } from "../../../utils/PhoneRegex";
import {
  sxBoxScreening,
  sxButton,
  sxError,
  sxInputEmail,
  sxInputPhone,
  sxLabel,
} from "./sxProps";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";

const StepConfirmacaoDados = (props: {
  backStep: () => void;
  endScreening: (cel: string, email: string) => void;
  sintoma: TipoOrientacaoTriagem | null;
  tipoAtendPaVirtual: TipoAtendRetorno;
}) => {
  const accessibility = useAccessibility();

  const { backStep, endScreening, sintoma, tipoAtendPaVirtual } = { ...props };
  const mobileScreen = useMediaQuery("(max-width: 768px)");

  useEffect(() => {
    const benef = getBenef();
    formik.setFieldValue("cel", cellphoneMask(benef?.cel || ""));
    formik.setFieldValue("email", benef?.email || "");
  }, []);

  const formik = useFormik({
    initialValues: { cel: "", email: "" },
    validationSchema: EmailCelularValidation,
    onSubmit: (values) => {
      endScreening(values.cel, values.email);
    },
    validateOnChange: false,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Box sx={sxBoxScreening}>
        <Typography
          style={accessibility.textStyleAccessibility}
          fontFamily={"Unimed-Sans"}
          component="h2"
          color="#383838"
        >
          <b>Sintoma: {sintoma!.descr}</b>
        </Typography>
        <Typography
          style={accessibility.textStyleAccessibility}
          fontFamily={"Unimed-Sans"}
          color="#4C4C4C"
        >
          Confirme os dados para finalizar{" "}
          <i>(ou edite, caso haja divergência)</i>
        </Typography>
        <div className="personal-data-confirmation-container">
          <div>
            <Typography
              style={accessibility.textStyleAccessibility}
              sx={sxLabel}
            >
              E-mail
            </Typography>
            <label htmlFor="email-input" aria-label="e-mail" />
            <OutlinedInput
              fullWidth
              id="email-input"
              type={"email"}
              value={formik.values.email}
              onChange={(e) => {
                formik.setFieldValue("email", e.target.value);
              }}
              name="email"
              error={!!formik.errors.email}
              maxRows={1}
              inputProps={{ maxLength: 100 }}
              style={accessibility.textStyleAccessibility}
              sx={sxInputEmail}
            />
            {formik.errors.email && (
              <Typography
                style={accessibility.textStyleAccessibility}
                sx={sxError}
              >
                {formik.errors.email}
              </Typography>
            )}
          </div>
          <div>
            <Typography
              style={accessibility.textStyleAccessibility}
              sx={sxLabel}
            >
              Telefone
            </Typography>
            <label htmlFor="phone-input" aria-label="telefone" />
            <OutlinedInput
              fullWidth
              id="phone-input"
              type={"tel"}
              value={formik.values.cel}
              onChange={(e) => {
                formik.setFieldValue("cel", cellphoneMask(e.target.value));
              }}
              name="cel"
              error={!!formik.errors.cel}
              maxRows={1}
              inputProps={{ maxLength: 15 }}
              style={accessibility.textStyleAccessibility}
              sx={sxInputPhone}
            />
            {formik.errors.cel && (
              <Typography
                style={accessibility.textStyleAccessibility}
                sx={sxError}
              >
                {formik.errors.cel}
              </Typography>
            )}
          </div>
        </div>
        <Button
          variant="contained"
          size="large"
          type="submit"
          sx={sxButton}
          style={accessibility.buttonStyleAccessibility}
          fullWidth={mobileScreen}
        >
          <span style={accessibility.buttonTextStyleAccessibility}>
            {tipoAtendPaVirtual === "VIRTUAL-AGENDA"
              ? "FINALIZAR"
              : "INGRESSAR NO ATENDIMENTO"}
          </span>
        </Button>
        <button
          className="back-button"
          onClick={backStep}
          style={accessibility.textStyleAccessibility}
        >
          <FontAwesomeIcon
            style={accessibility.textStyleAccessibility}
            icon={faChevronLeft}
          />
          &nbsp;&nbsp;<u>Voltar</u>
        </button>
      </Box>
    </form>
  );
};

export default StepConfirmacaoDados;
